import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html'
})
export class NotFoundComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
    

}